<template>
  <div
    class="mk-autoweb-video-block"
    :style="{
    background: 'url(' + element.commonStyle.backgroundImage + ')',
    'backgroundSize': 'cover'
  }"
  >
    <div class="subject-component-title center">{{ element.titleBarName }}</div>
    <div class="w1200 video-box">
      <div class="video-box-left">
        <p
          class="video-box-left-title ellipsis"
        >{{ childItem.propsValue.data.customField1[0].customField2 }}</p>
        <p
          class="video-box-left-desc"
          v-html="childItem.propsValue.data.customField1[0].customField3"
        ></p>
      </div>
      <div class="video-box-right">
        <div class="video-block" v-if="childItem.propsValue.data.customField1[0].customField4.id">
          <img
            class="video-block-img"
            :src="childItem.propsValue.data.customField1[0].customField4.cover_url | imgUrl"
          />
          <!-- <div class="video-block-bg"></div> -->
          <img
            class="video-block-play"
            data-id="81a17280ba6871edab1935a6ecca0102"
            src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
          />
        </div>
      </div>
    </div>
    <div class="mk-subject-btn-block">
      <a class="mk-subject-btn mk-ldy-btn">{{ childItem.propsValue.data.customField5.text }}</a>
    </div>
  </div>
</template>

<script>
import { buttonObject } from "../../../../../config/elementObject.js";
let buttonObjectTemp = JSON.parse(JSON.stringify(buttonObject));
buttonObjectTemp.text = "获取数智化解决方案";

import { mapState, mapMutations } from "vuex";
export default {
  name: "MkVideoTextWeb",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "视频",
          type: "list",
          children: [
            {
              code: "customField2",
              label: "标题",
              type: "text"
            },
            {
              code: "customField3",
              label: "描述",
              type: "richtext"
            },
            {
              code: "customField4",
              label: "视频",
              type: "video"
            }
          ]
        },
        {
          code: "customField5",
          label: "按钮",
          type: "button"
        }
      ],
      data: {
        customField1: [
          {
            customField2: "请输入视频标题",
            customField3: "请输入视频描述内容",
            customField4: {}
          }
        ],
        customField5: _.cloneDeep(buttonObjectTemp)
      }
      //  第一版本数据对象
      //      fields: [
      //         {
      //           code: "customField1",
      //           label: "标题",
      //           type: "text"
      //         },
      //         {
      //           code: "customField2",
      //           label: "描述",
      //           type: "richtext"
      //         },
      //         {
      //           code: "customField3",
      //           label: "视频",
      //           type: "video"
      //         },
      //         {
      //           code: "customField4",
      //           label: "按钮",
      //           type: "button"
      //         }
      //       ],
      //       data: {
      //         customField1: "请输入视频标题",
      //         customField2: "请输入视频描述内容",
      //         customField3: {},
      //         customField4: buttonObjectTemp
      //       }
    };
  },
  computed: {
    ...mapState({
      projectData: state => state.autowebStore.projectData
    })
  },
  mounted() {
    // 第一版本对象属性跟第二版本不一样，升级组件属性
    if (
      this.element &&
      this.element.childNode &&
      this.element.childNode.length > 0 &&
      _.filter(
        this.element.childNode[0].propsValue.fields,
        (f, fi) => f.code == "customField5"
      ).length == 0
    ) {
      // this.updatePropsValue();
    }
  },
  methods: {
    ...mapMutations(["setProjectData"]),
    // 升级组件属性方法
    updatePropsValue() {
      let updateFlag = false;
      this.projectData.elements = _.map(this.projectData.elements, el => {
        // 找到落地页当前组件
        if (el.uuid == this.element.uuid) {
          updateFlag = true;
          el.childNode = _.map(el.childNode, child => {
            let childDataTemp = JSON.parse(
              JSON.stringify(child.propsValue.data)
            );
            child.propsValue.fields = this.fields;
            child.propsValue.data = {
              customField1: [
                {
                  customField2: childDataTemp.customField1,
                  customField3: childDataTemp.customField2,
                  customField4: childDataTemp.customField3
                }
              ],
              customField5: childDataTemp.customField4
            };
            return child;
          });
          return el;
        } else {
          return el;
        }
      });
      updateFlag ? this.setProjectData(this.projectData) : "";
    }
  }
};
</script>

<style scoped lang="scss">
.subject-component-title {
  font-size: 22px;
  line-height: 44px;
  color: #e31924;
}

.mk-autoweb-video-block {
  width: 100%;
}

.mk-autoweb-video-block .video-box {
  max-width: 100%;
  height: 270px;
  margin-top: 30px;
}

.mk-autoweb-video-block .video-box-left {
  width: 40%;
  float: left;
}

.video-box-left .video-box-left-title {
  height: 60px;
  font-size: 22px;
  font-weight: bold;
  color: #e31924;
  line-height: 40px;
  padding: 20px 40px 0 30px;
}

.video-box-left .video-box-left-desc {
  font-size: 12px;
  color: #6f6f6f;
  line-height: 24px;
  padding: 20px 40px 0 30px;
}

.mk-autoweb-video-block .video-box-right {
  width: 50%;
  float: right;
}

.video-box-right .video-block {
  width: 350px;
  height: 200px;
  margin: 0 auto;
  position: relative;
  background: #000000;
}

.video-box-right .video-block .video-block-img {
  width: 100%;
  height: 100%;
}

.video-box-right .video-block .video-block-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #000000;
  opacity: 0.4;
}

.video-box-right .video-block .video-block-play {
  position: absolute;
  top: 75px;
  left: 150px;
  width: 50px;
  height: 50px;
}

.mk-subject-btn-block {
  width: 100%;
  height: 35px;
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
}

a.mk-subject-btn {
  display: block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  font-size: 16px;
  text-align: center;
  background-image: linear-gradient(131deg, #e5732d 0%, #e31924 52%);
  border-radius: 6px;
}

a:hover.mk-subject-btn {
  background-image: linear-gradient(-131deg, #e5732d 0%, #e31924 52%);
}
</style>
